export default {
  //支持米家
  support_mi_A: "本產品支援米家的中國大陸伺服器。",
  support_mi_B: "本產品支援米家的中國大陸、歐盟、英國伺服器。",
  support_mi_C: "本產品支援米家的中國大陸、歐盟、英國、俄羅斯伺服器。",
};
